import { StyledFormGroup } from "../styled-form-group";
import { ReasonsInput } from "./reasons-input";
import { NotesInput } from "./notes-input";
import { ResubscribeInput } from "./resubscribe-input";
import React from "react";
import "styled-components/macro";
import { FareInput } from "./fare-input";
import { NumTicketsInput } from "./numTickets-input";
import { FlightNumberInput } from "./flightNumber-input";
import { QuoteSourceInput } from "./quoteSource-input";

export function SkippingFormContent({
  formState,
  formActions,
  activeField,
  setActiveField,
}) {
  return (
    <>
      <StyledFormGroup
        label="Reasons"
        labelFor="reasons"
        helperText="What makes this opportunity a no-go?"
        activeField={activeField}
      >
        <ReasonsInput
          queryText={formState.reasonsQueryText}
          setQueryText={formActions.setReasonsQueryText}
          selectedItems={formState.reasons}
          onAdd={formActions.pushReason}
          onClear={formActions.clearReasons}
          onRemove={formActions.removeReason}
          activeField={activeField}
          setActiveField={setActiveField}
        />
      </StyledFormGroup>
      {!!(
        formState.price ||
        formState.numTickets ||
        formState.flightNumber ||
        formState.quoteSource
      ) && (
        <>
          <div
            css={`
              display: flex;
              justify-content: space-between;
            `}
          >
            <FareInput
              activeField={activeField}
              formState={formState}
              formActions={formActions}
              setActiveField={setActiveField}
              data_testid={"skipping_form__price_input"}
              helperText={
                "What was the ticket price quoted?"
              }
              label={"Quoted Price"}
              isVisible={formState.price !== null}
            />
            <NumTicketsInput
              activeField={activeField}
              formState={formState}
              formActions={formActions}
              setActiveField={setActiveField}
              data_testid={"skipping_form__numTickets_input"}
              helperText={"What was the number of tickets quoted?"}
              label={"Quoted Count"}
              isVisible={formState.numTickets !== null}
            />
          </div>
          <FlightNumberInput
            activeField={activeField}
            formState={formState}
            formActions={formActions}
            setActiveField={setActiveField}
            data_testid={"skipping_form__flightNumber_input"}
            helperText={"For which flight number did you receive a quote?"}
            label={"Quoted Flight No."}
            isVisible={formState.flightNumber !== null}
          />
          <QuoteSourceInput
            value={formState.quoteSource}
            onValueChange={formActions.setQuoteSource}
            activeField={activeField}
            setActiveField={setActiveField}
          />
        </>
      )}
      <NotesInput
        value={formState.notes}
        onValueChange={formActions.setNotes}
        activeField={activeField}
        setActiveField={setActiveField}
        height={"200px"}
      />
      <ResubscribeInput
        disabled={formState.isFlopptions}
        value={formState.resubscribe}
        onValueChange={formActions.setResubscribe}
        activeField={activeField}
        setActiveField={setActiveField}
      />
    </>
  );
}
